import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import BankAccounts from "@/pages/BankAccounts";
import Statements from "@/pages/Statements";
import Invoices from "@/pages/Invoices";
import RecurringInvoices from "@/pages/RecurringInvoices";
import PublicPaymentPlan from "@/pages/PublicPaymentPlan";
import Transactions from "@/pages/Transactions";
import Reconciliation from "@/pages/Reconciliation";
import MissingMonths from "@/pages/MissingMonths";
import Advisory from "./pages/Advisory";
import Reports from "@/pages/Reports";
import TeamUsers from "@/pages/TeamUsers";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Clients from "@/pages/Clients";
import ReviewQueue from "@/pages/ReviewQueue";
import PlatformAdmin from "@/pages/PlatformAdmin";
import ClientPortal from "@/pages/ClientPortal";
import Messages from "@/pages/Messages";
import AuditLog from "@/pages/AuditLog";
import EnterpriseGate from "@/components/EnterpriseGate";
import { useAuth } from "@/lib/auth";

function ClientsGated() {
  const { tenant } = useAuth();
  return (
    <EnterpriseGate tenant={tenant} title="Clients" subtitle="Multi-tenant module" testid="clients-gate">
      <Clients />
    </EnterpriseGate>
  );
}

function ReviewQueueGated() {
  const { tenant } = useAuth();
  return (
    <EnterpriseGate tenant={tenant} title="Review queue" subtitle="Cross-tenant inbox" testid="queue-gate">
      <ReviewQueue />
    </EnterpriseGate>
  );
}
import UserManual from "@/pages/docs/UserManual";
import AdminManual from "@/pages/docs/AdminManual";
import ThemeApplier from "@/components/ThemeApplier";
import MagicLogin from "@/pages/MagicLogin";

export default function App() {
  return (
    <AuthProvider>
      <ThemeApplier />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/invite/:token" element={<AcceptInvite />} />
          <Route path="/magic" element={<MagicLogin />} />
          <Route path="/pay-plan/:token" element={<PublicPaymentPlan />} />
          <Route path="/client" element={<ClientPortal />} />
          <Route path="/docs/user-manual" element={<UserManual />} />
          <Route path="/docs/admin-manual" element={<AdminManual />} />
          <Route path="/docs" element={<Navigate to="/docs/user-manual" replace />} />
          <Route path="/billing" element={<Navigate to="/app/billing" replace />} />
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="accounts" element={<BankAccounts />} />
            <Route path="statements" element={<Statements />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="reconciliation" element={<Reconciliation />} />
            <Route path="missing-months" element={<MissingMonths />} />
            <Route path="advisory" element={<Advisory />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="recurring-invoices" element={<RecurringInvoices />} />
            <Route path="reports" element={<Reports />} />
            <Route path="users" element={<TeamUsers />} />
            <Route path="messages" element={<Messages />} />
            <Route path="billing" element={<Billing />} />
            <Route path="settings" element={<Settings />} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="clients" element={<ClientsGated />} />
            <Route path="queue" element={<ReviewQueueGated />} />
            <Route path="admin" element={<PlatformAdmin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
